import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Kicker } from '@/components/Kicker';

function KPI({ label, value, hint, testid, tone }) {
  return (
    <div className="pn-card p-6" data-testid={testid}>
      <div className="text-xs font-semibold uppercase tracking-wide text-[#4A4D52]">{label}</div>
      <div className={`mt-2 font-display text-3xl font-semibold ${tone === 'accent' ? 'text-[#E2611C]' : 'text-[#14171C]'}`}>{value}</div>
      {hint && <div className="mt-1 text-xs text-[#4A4D52]">{hint}</div>}
    </div>
  );
}

export default function AdminOverview() {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({ queryKey: ['admin', 'kpis'], queryFn: async () => (await api.get('/admin/kpis')).data });

  const lastSync = data?.last_sync;
  const status = lastSync?.status || '—';
  const startedAt = lastSync?.started_at ? new Date(lastSync.started_at).toLocaleString() : '—';

  return (
    <section>
      <Kicker>{t('admin.title')}</Kicker>
      <h1 className="mt-3 font-display text-3xl font-semibold text-[#14171C]">{t('admin.nav.overview')}</h1>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <KPI testid="admin-kpi-total-products" label={t('admin.kpi.total_products')} value={isLoading ? '–' : (data?.products?.total ?? 0)} />
        <KPI testid="admin-kpi-public-products" label={t('admin.kpi.public_products')} value={isLoading ? '–' : (data?.products?.favorites ?? 0)} tone="accent" />
        <KPI label={t('admin.kpi.customer_specific')} value={isLoading ? '–' : (data?.products?.customer_specific ?? 0)} />
        <KPI testid="admin-kpi-active-users" label={t('admin.kpi.users')} value={isLoading ? '–' : (data?.users?.total ?? 0)} hint={`${data?.users?.linked ?? 0} ${t('admin.kpi.linked')}`} />
        <KPI label={t('admin.kpi.documents')} value={isLoading ? '–' : (data?.documents?.total ?? 0)} hint={`${data?.documents?.wpz ?? 0} ${t('admin.kpi.wpz')}`} />
        <KPI testid="admin-kpi-last-sync" label={t('admin.kpi.last_sync')} value={isLoading ? '–' : status} hint={startedAt} />
        <KPI label={t('admin.kpi.errors')} value={isLoading ? '–' : (data?.errors_recent ?? 0)} />
        <KPI label={t('admin.nav.requests')} value={isLoading ? '–' : (data?.requests?.new ?? 0)} />
      </div>
    </section>
  );
}
